export class SchemaNotDefinedError extends Error {
  constructor() {
    super(
      'Widget API schema was not defined. Ensure that schema data is provided using the defineSchemaAPI method.'
    );
  }
}
